module.exports = __webpack_public_path__ + "static/img/jojotimes.4bde2b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/jojotimes.png
// module id = l+UW
// module chunks = 46